var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"row vh-100"},[_c('div',{staticClass:"col-md-12"},[_c('iframe',{attrs:{"src":'data:application/pdf;base64,' + _vm.docIframe,"width":"100%","height":"100%"}})])]),_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }